/**
 * The console's sections, each shown to operators holding its permission, or one of its permissions (ADR 0012); the
 * queues to everyone. Support reads enterprises and orders (ADM-5, cards 079 and 080); resolvers work disputes (card
 * 090).
 */
export const NAV = [
  { to: "/", key: "queues", end: true },
  { to: "/verification", key: "verification", needs: "ops:verification.review" },
  { to: "/enterprises", key: "enterprises", needs: ["ops:verification.review", "ops:support.read"] },
  { to: "/orders", key: "orders", needs: "ops:support.read" },
  { to: "/disputes", key: "disputes", needs: "ops:dispute.resolve" },
  { to: "/product-reviews", key: "productReviews", needs: "ops:catalog.manage" },
  { to: "/products", key: "products", needs: "ops:catalog.manage" },
  { to: "/categories", key: "categories", needs: "ops:catalog.manage" },
  { to: "/risk-lists", key: "riskLists", needs: "ops:risk.manage" },
  { to: "/settings", key: "settings", needs: "ops:config.manage" },
  { to: "/audit", key: "audit", needs: "ops:audit.read" },
] as const satisfies readonly {
  to: string;
  key: string;
  end?: boolean;
  needs?: string | readonly string[];
}[];

export type NavItem = (typeof NAV)[number];

export function visibleNav(permissions: readonly string[]): NavItem[] {
  return NAV.filter(
    (item) =>
      !("needs" in item) ||
      (typeof item.needs === "string" ? [item.needs] : item.needs).some((needed) =>
        permissions.includes(needed),
      ),
  );
}
